import React from 'react';
import _ from 'lodash';
import {Box} from '@mui/material';
import {useQueryParam} from '../../util/react_hooks.js';
import TarotmailCustomerComp from '../../components/TarotmailCustomerComp.js';
import {withTitle} from '../../title.js';

const TarotmailCustomer = ()=>{
    let [id] = useQueryParam('id');
    return <Box sx={{
        // background: 'linear-gradient(45deg, rgba(255, 69, 215, 1) 0%, rgba(52, 33, 181, 1) 100%)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
    }}>
      <TarotmailCustomerComp id={id} absolute/>
    </Box>;
};

export default withTitle('מסר שבועי במייל', TarotmailCustomer);
